import React, { useState } from 'react';
import LicenseAdminPanel from './LicenseAdminPanel';
import WebLicenseAdmin from './WebLicenseAdmin';
import ManualRegisterPanel from './ManualRegisterPanel';
import UserLicenseManagementPanel from './UserLicenseManagementPanel';

const AdminLicensesPanel = () => {
    const [subTab, setSubTab] = useState('general');

    const tabs = [
        { id: 'general', label: '📋 General / Activación', icon: '📋' },
        { id: 'web', label: '🌐 Versión Web', icon: '🌐' },
        { id: 'register', label: '✍️ Registro Manual', icon: '✍️' },
        { id: 'cleanup', label: '🧹 Limpieza e Inactivos', icon: '🧹' }
    ];

    return (
        <div className="admin-licenses-consolidated" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={{
                display: 'flex',
                gap: '10px',
                borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                paddingBottom: '10px',
                overflowX: 'auto'
            }}>
                {tabs.map(t => (
                    <button
                        key={t.id}
                        onClick={() => setSubTab(t.id)}
                        style={{
                            background: subTab === t.id ? 'var(--admin-btn-custom, #2196F3)' : 'rgba(255, 255, 255, 0.05)',
                            color: '#fff',
                            border: 'none',
                            padding: '10px 18px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '0.85rem',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            transition: 'all 0.2s ease',
                            whiteSpace: 'nowrap'
                        }}
                        onMouseEnter={e => {
                            if (subTab !== t.id) e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                        }}
                        onMouseLeave={e => {
                            if (subTab !== t.id) e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                        }}
                    >
                        <span>{t.icon}</span>
                        {t.label}
                    </button>
                ))}
            </div>

            <div className="consolidated-license-content">
                {subTab === 'general' && <LicenseAdminPanel />}
                {subTab === 'web' && <WebLicenseAdmin />}
                {subTab === 'register' && <ManualRegisterPanel />}
                {subTab === 'cleanup' && <UserLicenseManagementPanel />}
            </div>
        </div>
    );
};

export default AdminLicensesPanel;
